module.exports = __webpack_public_path__ + "img/pro4-img4.ebf775b6.jpg";